import { SubscriptionApi } from "../../../../../../../../../services/Api/Subscription/subscriptionTypes";

export const getSubscriptionExternalId = (subscription: SubscriptionApi) => {
	const ids: string[] = [`#${subscription.external_id}`];
	if (subscription.monthly_sub_item) {
		ids.push(`#${subscription.monthly_sub_item.external_id}`);
	}
	return ids.join(", ");
};

export const isSubscriptionUninstalled = (subscription: SubscriptionApi) => {
	return (
		subscription.status === "CANCELLED" ||
		subscription.status === "PAUSED" ||
		subscription.status === "NON_RENEWING"
	);
};

export const areAllSubscriptionsCancelled = (subscriptions: SubscriptionApi[]) => {
	return subscriptions.every((subscription) => subscription.status === "CANCELLED");
};
